import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

export const curriculumData = {
  curriculum: [
    {
      title: 'Programming Foundations',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Eleven.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '6 weeks',
      tag: null,
      data: [
        'Strengthen your foundational programming skills through a series of hands-on activities and curated problem statements.',
      ],
      skills: [
        'Java',
        'OOPs',
        'Collections',
        'Exception Handling',
        'Debugging',
        'JUnit',
      ],
      anchor: 'programming-foundation',
      cardTitle: null,
      cards: [],
    },
    {
      title: 'Developer Essentials',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Eleven.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '2 weeks',
      tag: null,
      data: [
        `Get introduced to key skills needed to be an effective SDET through mini-projects and hands-on developer activities.`,
      ],
      skills: [
        'Agile',
        'Linux',
        'Git',
        'HTML Basics',
        'Gradle',
        'Bugzilla',
        'Test Rails',
      ],
      anchor: 'developer-essentials',
      cardTitle: null,
      cards: [],
    },
    {
      title: 'Testing Essentials',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Eleven.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '2 weeks',
      tag: null,
      data: [
        `Through carefully designed workshops and activities, master testing fundamentals like Test Strategy, Test Data Generation, Test Case Design, Defect Life Cycle, Software Testing Levels, Software Testing Types, Estimation, Metrics, and Testability.`,
      ],
      skills: [
        'SQL Queries',
        'Data Manipulation',
        'Data Aggregation',
        'Joins',
        'Subqueries',
        'Query Optimization',
      ],
      anchor: 'testing-essentials',
      cardTitle: null,
      cards: [],
    },
    {
      title: 'Web Automation with Selenium',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Eleven.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '12 weeks',
      tag: null,
      data: [],
      skills: [],
      anchor: 'web-automation-selenium',
      cardTitle: null,
      cards: [
        {
          data: [
            `<p>Through a carefully designed series of hands-on workshops and mini-projects, learn fundamental testing concepts that are essential to become a strong SDET.</p>`,
          ],
          title: '',
          skills: [
            'Selenium',
            'Web Driver',
            'XPath',
            'Apache POI',
            'Page Object Model',
            'Framework',
            'Grid',
            'TestNG',
          ],
          tag: 'python-foundations',
        },
        {
          data: [
            `<p><strong>QKart</strong> - Create Automated Test Cases for a Flipkart like web-based application with guidance from experienced mentors.</p>`,
          ],
          title: 'Work-like Professional Project',
          skills: [],
          tag: 'python-foundations',
        },
      ],
    },
    {
      title: 'GenAI Foundations',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Two.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '1 weeks',
      tag: null,
      data: [
        '<p>Gain end-to-end LLM practice, and prompt engineering for advanced solutions like RAG</p><ul><li>Develop foundational knowledge of LLMs, their use cases, ecosystem, providers, model types, and prompt engineering.</li><li>10x your productivity as a tester using Bolt, Cursor, and other GenAI tools to speed up prototyping, code reviews, and documentation.</li></ul>',
      ],
      skills: [
        'LLM',
        'Prompt Engineering',
        "OpenAI API's",
        'RAG',
        'Bolt',
        'Cursor',
      ],
      anchor: 'genai-foundations',
      cardTitle: null,

      cards: [],
    },
    {
      title: 'Interview Blitz',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Six.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '2 weeks',
      tag: null,
      chip: '',
      data: [
        '<p>Refine your learnings from previous Sprints and practice answering conceptual interview questions, DSA questions, etc.</p><ul><li>Perfect the art of cracking the tester roles related DSA interviews through multiple DSA sessions</li><li>Practice the most commonly asked interview questions to ace your interview</li><li>Hands-on practice for Automations, Takehomes and Aptitude Rounds</li><li>Get confident for your upcoming interviews by giving an AI mock interview</li></ul>',
      ],
      skills: [
        'Technical Questions',
        'Behavioral Questions',
        'Online Assessments',
        'DSA Mocks',
        'Mock Interviews',
        'Aptitude',
      ],
      anchor: 'interview-blitz',
      cardTitle: null,
      cards: [],
    },
    {
      title: 'QA Advanced Concepts',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Six.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '8 weeks',
      chip: 'career step up',
      tag: null,
      data: [
        '<p>Learn how to create a Selenium framework, basics of BDD and learn advanced testing concepts in API testing and Performance testing.</p><ul><li>Create a Selenium framework - keyword driven, page object model and page factory</li><li>Learn about logging and extent report</li><li>Learn data manipulation on excel files using Apache POI</li><li>Learn how to trigger Jenkins job for the project.</li><li>Learn about BDD and apply it using Cucumber.</li><li>Learn to do API Testing using postman and REST assured.</li><li>Learn about performance analysis, measurement & reporting, performance testing using JMeter</li><li>Implement learnings in API & Performance testing using a professional real time project</li></ul>',
      ],
      skills: [
        'Postman',
        'REST assured API',
        'Performance Analysis',
        'Measurement & Reporting',
        'JMeter',
        'Page object model',
        'Page factory',
        'Extent report',
        'Jenkins',
        'Cucumber',
      ],
      anchor: 'qa-advanced-concepts',
      cardTitle: null,
      cards: [],
    },
    {
      title: 'Data Structures and Algorithms',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Six.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '12 weeks',
      chip: 'career step up',
      tag: null,
      data: [],
      skills: [],
      anchor: 'dsa',
      cardTitle: null,
      cards: [
        {
          data: [
            '<p>Get introduced to DSA with problems related to arrays and strings.</p><ul><li>Develop logic building skills by solving simple math, recursion, and implementation problems</li><li>Understand Time & Space complexity</li><li>Get introduced to data structures & traversals – LinkedList & Trees</li></ul>',
          ],
          title: 'DSA Foundations',
          skills: [
            'Logic Building',
            'Recursion',
            'Collections',
            'Introduction to Data Structures',
            'Space and Time Complexity',
          ],
          tag: 'dsa-foundations',
        },
        {
          data: [
            '<p>Learn various patterns of problem solving involving arrays & strings.</p><ul><li>Get introduced to problem patterns that involve arrays</li><li>Learn how to recognize these patterns in problems</li><li>Solve the most frequently asked problems across these pattern</li></ul>',
          ],
          title: 'Array Patterns and Problems',
          skills: [
            'Matrix',
            'Two Pointers',
            'Sliding Window',
            'Prefix Sum',
            'Bit Manipulation',
            'Sorting',
            'Binary Search',
          ],
          tag: 'array-patterns',
        },
        {
          data: [
            '<p>Learn about new data structures and how to implement and apply them to solve DSA problems.</p><ul><li>Solve DSA problems involving Hash, Queue, and Stack</li><li>Learn and solve Linked List related patterns and problems</li><li>Leverage BFS/DFS effectively to solve multiple tree problems</li></ul>',
          ],
          title: 'Stack/Queue, Linked List, Tree',
          skills: [
            'Matrix',
            'Queue',
            'Hash',
            'Linked List',
            'Binary Tree',
            'Binary Search Tree',
            'BFS',
            'DFS',
          ],
          tag: 'data-structures',
        },
      ],
    },
  ],
};
